export default function IosColorWand() {
  return (
    <div
      className="ion-icon-ios-color-wand"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<polygon points="198.011,159.22 163.968,193.337 420.064,450 454,415.883 	"/>
	<rect x="182" y="62" width="32" height="64"/>
	<rect x="182" y="266" width="32" height="64"/>
	<rect x="274" y="178" width="64" height="32"/>
	<polygon points="303.941,112.143 281.314,89.465 236.06,134.82 258.687,157.498 	"/>
	<polygon points="92.06,112.143 137.314,157.498 159.941,134.82 114.687,89.465 	"/>
	<polygon points="92.06,279.141 114.687,301.816 159.941,256.462 137.314,233.784 	"/>
	<rect x="58" y="178" width="64" height="32"/>
</g>
</svg>
`,
      }}
    />
  )
}
